@import './pk-list-item.variables';

:host {
  @apply block;
}
